import React, { useState } from "react"
import { ArrowLeft, MailCheck } from "lucide-react"
import { Link } from "../router"
import { Button, ErrorNotice } from "../ui"
import { PasswordRecoveryLayout } from "./PasswordRecoveryLayout"

export function ForgotPasswordPage() {
  const [busy, setBusy] = useState(false)
  const [email, setEmail] = useState("")
  const [error, setError] = useState(null)
  const [sent, setSent] = useState(false)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      const response = await fetch("/api/v1/auth/forgot_password", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ email })
      })
      if (!response.ok) throw new Error("We couldn’t send reset instructions. Please try again.")
      setSent(true)
    } catch (caught) {
      setError(caught)
    } finally {
      setBusy(false)
    }
  }

  return (
    <PasswordRecoveryLayout>
      {sent ? (
        <div className="recovery-result" aria-live="polite">
          <span className="recovery-result__icon"><MailCheck size={27} aria-hidden="true" /></span>
          <p className="eyebrow">Check your inbox</p>
          <h2>Reset instructions are on the way</h2>
          <p>If an account exists for <strong>{email}</strong>, you’ll receive an email with a secure reset link shortly.</p>
          <p className="recovery-help">Don’t see it? Check your spam folder, or wait a minute and try again.</p>
          <Button type="button" variant="secondary" onClick={() => setSent(false)}>Try another email</Button>
          <Link className="recovery-back" to="/login"><ArrowLeft size={15} aria-hidden="true" /> Back to sign in</Link>
        </div>
      ) : (
        <>
          <p className="eyebrow">Forgot your password?</p>
          <h2>Let’s get you back in</h2>
          <p>Enter the email address you use for Baseball Hub. We’ll send you a secure link to choose a new password.</p>
          <ErrorNotice error={error} />
          <form className="form-stack" onSubmit={submit}>
            <label htmlFor="recovery-email">Email address<input id="recovery-email" name="email" type="email" autoComplete="email" autoFocus value={email} onChange={event => setEmail(event.target.value)} required /></label>
            <Button type="submit" disabled={busy}>{busy ? "Sending…" : "Send reset instructions"}</Button>
          </form>
          <Link className="recovery-back" to="/login"><ArrowLeft size={15} aria-hidden="true" /> Back to sign in</Link>
        </>
      )}
    </PasswordRecoveryLayout>
  )
}
